export default "__VITE_ASSET__Cf2LANpK__"